<div fxLayout="column">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else quickpayFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="quickpayFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #quickpayFlexColumnTemplate>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
  <div fxFlex="100%" fxLayout="column" fxLayoutGap.lt-md="10px" class="large-paragraph-spacing" [ngClass]="{ 'ie-display': isBrowserIE }">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else quickpayMessagesFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="quickpayMessagesFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else quickpayMainFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="quickpayMainFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #quickpayMessagesFlexColumnTemplate>
  <div fxFlex="5%" fxHide.lt-md></div>
  <!-- Welcome Messages -->
  <div
    fxFlex="90%"
    fxLayoutAlign="center center"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="showWelcomeMessagesSpinner"
  >
    <mat-spinner color="accent" diameter="32"></mat-spinner>
  </div>
  <div
    fxFlex="90%"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="!showWelcomeMessagesSpinner && this.welcomeMessageList.length > 0"
  >
    <div
      ngStyle.gt-sm="padding-left: 24px; padding-right: 24px"
      ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
      class="extra-large-display-text normal-paragraph-spacing center-text"
      [ngClass]="getMessageCssClass(item)"
      *ngFor="let item of this.welcomeMessageList"
    >
      {{ item.messageText }}
    </div>
  </div>
  <!-- Temporary Messages -->
  <div
    fxFlex="90%"
    fxLayoutAlign="center center"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="showTemporaryMessagesSpinner"
  >
    <mat-spinner color="accent" diameter="32"></mat-spinner>
  </div>
  <div
    fxFlex="90%"
    ngStyle.gt-sm="padding-left: 24px; padding-right: 24px"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="!showTemporaryMessagesSpinner && this.temporaryMessageList.length > 0"
  >
    <div
      class="large-display-text normal-paragraph-spacing center-text"
      [ngClass]="getMessageCssClass(item)"
      *ngFor="let item of this.temporaryMessageList"
    >
      {{ item.messageText }}
    </div>
  </div>
  <!-- General Messages - 01/10/2023-->
  <div
    fxFlex="90%"
    fxLayoutAlign="center center"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="showGeneralMessagesSpinner"
  >
    <mat-spinner color="accent" diameter="32"></mat-spinner>
  </div>
  <div
    fxFlex="90%"
    ngStyle.gt-sm="padding-left: 24px; padding-right: 24px"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="!showGeneralMessagesSpinner && this.generalMessageList.length > 0"
  >
    <div
      class="large-display-text normal-paragraph-spacing center-text"
      [ngClass]="getMessageCssClass(item)"
      *ngFor="let item of this.generalMessageList"
    >
      {{ item.messageText }}
    </div>
  </div>
  <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #quickpayMainFlexColumnTemplate>
  <div fxFlex="50%" fxHide.lt-md></div>
  <div fxFlex="500px" fxFlex.lt-md="100%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px;">
    <div class="display-text normal-paragraph-spacing">
      <mat-card>
        <mat-card-content>
          <div fxLayout="column">
            <div *ngIf="isBrowserIE; else quickpayFormFlexColumnTemplate">
              <ng-container *ngTemplateOutlet="quickpayFormFlexColumnTemplate"></ng-container>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div fxFlex="50%" fxHide.lt-md></div>
</ng-template>

<ng-template #quickpayFormFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text primary-dark-color-important">
      <b><span i18n="@@quickpay.form.title">quickpay.form.title</span></b>
    </div>
    <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 16px;"></div>
    <div class="display-text primary-dark-color-important">
      <form [formGroup]="quickpayForm">
        <div fxLayout="column">
          <div
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showquickpayTimeoutError"
          >
            <b><span i18n="@@quickpay.form.login-timeout-message.error.1">quickpay.form.login-timeout-message.error.1</span></b>
          </div>
          <div class="form-group" fxLayoutAlign="center center" *ngIf="partiVisible">
            <mat-form-field fxFlex="80%" fxFlex.lt-md="90%">
              <label for="acct_type">How do you want to look up your account?</label>
              <div class="form-group" fxLayoutAlign="center center" *ngIf="partiVisible">
                <label for="space_id"><br></label>
              </div>
              <mat-select [(value)]="selected">
                <mat-option value="acctId">Account Number</mat-option>
                <mat-option value="stdId">Student Number</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="form-group" *ngIf="partiVisible">
            <mat-form-field fxFlex="80%" fxFlex.lt-md="90%">
              <input
                matInput
                i18n-placeholder="@@quickpay.form.parti.label"
                placeholder="quickpay.form.parti.label"
                type="text"
                [formControl]="partiFormControl"
                autocomplete="off"
                required
              />
              <span matPrefix><mat-icon class="mat-icon-prefix">person</mat-icon>&nbsp;</span>
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="form-group" *ngIf="acct_selectedValue ==='stdId'">
            <mat-form-field fxFlex="80%" fxFlex.lt-md="90%">
              <input
                matInput
                i18n-placeholder="@@quickpay.form.parti.label"
                type="text"
                [formControl]="partiFormControl"
                autocomplete="off"
                required
              />
              <span matPrefix><mat-icon class="mat-icon-prefix">person</mat-icon>&nbsp;</span>
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="lnameVisible">
            <mat-form-field fxFlex="80%" fxFlex.lt-md="90%">
              <input
                matInput
                i18n-placeholder="@@quickpay.form.lname.label"
                placeholder="quickpay.form.lname.label"
                type="text"
                [formControl]="lnameFormControl"
                autocomplete="off"
                required
              />
              <span matPrefix><mat-icon class="mat-icon-prefix">person</mat-icon>&nbsp;</span>
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="zipVisible">
            <mat-form-field fxFlex="80%" fxFlex.lt-md="90%">
              <input
                #userZipRef
                matInput
                i18n-placeholder="@@quickpay.form.zip.label"
                placeholder="quickpay.form.zip.label"
                type="text"
                [formControl]="zipFormControl"
                autocomplete="off"
                required
              />
              <span matPrefix><mat-icon class="mat-icon-prefix">123</mat-icon>&nbsp;</span>
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing normal-paragraph-pre-spacing">
            <re-captcha formControlName="recaptchaFormControl" siteKey="{{ recaptchaSiteKey }}" required></re-captcha>
          </div>
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            class="display-text normal-paragraph-spacing"
            *ngIf="submitButtonVisible"
          >
            <button
              mat-flat-button
              color="primary"
              (click)="submitUser()"
              i18n="@@quickpay.form.submit-button.label"
              *ngIf="submitButtonVisible"
            >
              quickpay.form.submit-button.label
            </button>
            <span *ngIf="submitButtonVisible">&nbsp;&nbsp;</span>
            <button
              mat-stroked-button
              color="primary"
              (click)="cancelLogin()"
              i18n="@@quickpay.form.cancel-button.label"
              *ngIf="submitButtonVisible"
            >
              quickpay.form.cancel-button.label
            </button>
          </div>
          <div
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showLockedOutError"
          >
            <b><span i18n="@@quickpay.form.locked-out-message.error.1">quickpay.form.locked-out-message.error.1</span></b>
          </div>
          <div
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showTemporaryPasswordError"
          >
            <b><span i18n="@@quickpay.form.temporary-password-message.error.1">quickpay.form.temporary-password-message.error.1</span></b>
          </div>
          <div
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showExpiredTemporaryPasswordError"
          >
            <b
              ><span i18n="@@quickpay.form.expired-temporary-password-message.error.1"
                >quickpay.form.expired-temporary-password-message.error.1</span
              ></b
            >
          </div>
          <div
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showStdNumPartiError">
            <b><span i18n="@@quickpay.form.stdNum-count-message.error.1">quickpay.form.stdNum-count-message.error.1</span></b>
          </div>
          <div
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showNoteCountError">
            <b><span i18n="@@quickpay.form.note-count-message.error.1">quickpay.form.note-count-message.error.1</span></b>
          </div>
          <div
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showLoginError"
          >
            <b><span i18n="@@quickpay.form.login-message.error.1">quickpay.form.login-message.error.1</span></b>
          </div>
          <div
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showLoginError"
          >
            <b><span i18n="@@quickpay.form.login-message.error.2">quickpay.form.login-message.error.2</span></b>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="showLoginSpinner">
            <mat-spinner color="accent" diameter="32"></mat-spinner>
          </div>
          <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 16px;" *ngIf="registerVisible"></div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
